/* eslint-disable arrow-body-style */
/* eslint-disable padding-line-between-statements */

import { ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import _, { update } from 'lodash';
import PropTypes from 'prop-types';
import React, { useCallback, useContext, useEffect, useMemo, useState } from 'react';
import { TranslatorContext } from '@jutro/locale';
import metadata from './ConstructionDetailsAccordion.metadata.json5';
import styles from './ConstructionDetailsAccordion.module.scss'


const ConstructionDetailsAccordion = props => {
    const {
        onTabChangeObj, yesNo
    } = props;


    // eslint-disable-next-line react-hooks/exhaustive-deps
    const overrideProps = {
        '@field': {           
            className:styles.fieldStyle
        },
        roofUpgraded: {
            value: _.get(onTabChangeObj, 'latestJobPolicyPeriod.lobs.homeOwners_tfpa.dwellingDTO.constructionDetails.roofUpgraded') ? `${'Yes'}(${_.get(onTabChangeObj, 'latestJobPolicyPeriod.lobs.homeOwners_tfpa.dwellingDTO.constructionDetails.roofUpgradeYear')})` : 'No'
        },
        heatingUpgraded: {
            value: _.get(onTabChangeObj, 'latestJobPolicyPeriod.lobs.homeOwners_tfpa.dwellingDTO.constructionDetails.heatingUpgraded') ? `${'Yes'}(${_.get(onTabChangeObj, 'latestJobPolicyPeriod.lobs.homeOwners_tfpa.dwellingDTO.constructionDetails.heatingUpgradeYear')})` : 'No'
        },
        plumbingUpgraded: {
            value: _.get(onTabChangeObj, 'latestJobPolicyPeriod.lobs.homeOwners_tfpa.dwellingDTO.constructionDetails.plumbingUpgraded') ? `${'Yes'}(${_.get(onTabChangeObj, 'latestJobPolicyPeriod.lobs.homeOwners_tfpa.dwellingDTO.constructionDetails.plumbingUpgradeYear')})` : 'No'
        },
        wiringUpgraded: {
            value: _.get(onTabChangeObj, 'latestJobPolicyPeriod.lobs.homeOwners_tfpa.dwellingDTO.constructionDetails.wiringUpgraded') ? `${'Yes'}(${_.get(onTabChangeObj, 'latestJobPolicyPeriod.lobs.homeOwners_tfpa.dwellingDTO.constructionDetails.wiringUpgradeYear')})` : 'No'
        }
    };


    const resolvers = {
        resolveClassNameMap: styles,
        resolveCallbackMap: {

        }
    };


    return (
        <ViewModelForm
            uiProps={metadata.pageContent}
            overrideProps={overrideProps}
            model={onTabChangeObj}
            // onModelChange={updateWizardData}
            // onValueChange={writeValue}
            // showErrors={showErrors}
            // onValidationChange={setComponentValidation}
            // callbackMap={resolvers.resolveCallbackMap}
            classNameMap={resolvers.resolveClassNameMap}
        // componentMap={resolvers.resolveComponentMap}
        />
    );
};


ConstructionDetailsAccordion.propTypes = {
    history: PropTypes.shape({
        push: PropTypes.func,
    }).isRequired,
    //authHeader: PropTypes.shape({}).isRequired,
};
export default ConstructionDetailsAccordion;
